import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Alert, Button, Col, Form, Input, Row, Spin } from "antd";
import axios from "axios";
import { axiosErrorHandler } from "../../../swzutils";
import API from "../../../API";
const TOTPActivateForm = ({ secret, url, onCompleted }) => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [form] = Form.useForm();
    const onError = (errMsge) => {
        setLoading(false);
        setErrorMessage(errMsge);
    };
    const activateMFA = (formValues) => {
        setLoading(true);
        axios.post('/admin/v1/users/me/multi-factor-auth/activate', {
            "oneTimePassword": formValues.oneTimePassword
        }).then((response) => {
            form.setFieldsValue({
                "password": "",
            });
            setLoading(false);
            setErrorMessage(null);
            onCompleted();
        }).catch((error) => {
            axiosErrorHandler(error, onError);
        }).finally(() => {
            setLoading(false);
        });
    };
    const qrURL = `${API.origin()}/admin/v1/barcode?data=${encodeURIComponent(url)}&symbology=QR&width=400&height=400`;
    return (_jsxs(Spin, { spinning: loading, children: [_jsx("br", {}), _jsxs(Form, { layout: "vertical", form: form, onFinish: activateMFA, children: [_jsx(Row, { justify: "center", children: _jsxs(Col, { xl: 18, children: [_jsx("p", { className: "text-center", children: "Scan the QR code or enter the secret into your authenticator" }), _jsx("img", { src: qrURL, alt: "Authenticator QR Code", width: 400, height: 400, style: {
                                        display: 'block',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    } }), _jsx("pre", { className: "text-center", style: { fontSize: '14pt' }, children: secret }), errorMessage &&
                                    _jsx(Alert, { style: { marginBottom: 30 }, title: "Multi-factor authentication activation failed", description: errorMessage, type: "error", showIcon: true }), _jsx("p", { className: "text-center", children: "Once setup, generate a passcode and enter it below to activate multi-factor authentication" }), _jsx(Form.Item, { name: "oneTimePassword", label: "Enter passcode", rules: [
                                        { required: true, message: 'Please input a 6 digit code from your authenticator.' },
                                        { min: 6, message: 'Passcode should be 6 digits long' }
                                    ], children: _jsx(Input.OTP, { length: 6 }) })] }) }), _jsx(Row, { justify: "end", children: _jsx(Button, { type: "primary", htmlType: "submit", size: "large", className: "pull-right", children: "Activate" }) })] })] }));
};
export default TOTPActivateForm;
